"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _index = _interopRequireDefault(require("@/directive/permission/index.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
// 权限判断指令
var _default2 = exports.default = {
  directives: {
    permission: _index.default
  },
  props: {
    user: {
      type: Object,
      default: function _default() {
        return {
          id: '',
          uuid: '',
          prefix: '',
          givenName: '',
          middleName: '',
          familyName: '',
          suffix: '',
          genderCode: '',
          race: '',
          nationality: '',
          phone: '',
          mobile: '',
          birthday: '',
          website: '',
          jobTitle: '',
          department: '',
          orgName: '',
          yrInRole: '',
          bio: '',
          othEmail: [{
            emailType: 'Work',
            value: ''
          }, {
            emailType: 'Work',
            value: ''
          }]
        };
      }
    },
    proOrganizationList: {
      type: Array,
      default: function _default() {
        return [];
      },
      // 默认空数组
      validator: function validator(value) {
        return value === null || Array.isArray(value);
      } // 允许 null 或数组
    }
  },
  data: function data() {
    return {
      countryList: [],
      genderList: [],
      prefixList: ['', 'Mr', 'Miss', 'Mrs', 'Ms', 'Dr', 'Prof', 'Sir', 'Lady'],
      suffixList: ['', 'Sr.', 'Jr.', 'II', 'III'],
      yearInRoleList: ['0-1', '2-5', '6-10', '11-15', '15+'],
      typeList: ['Home', 'Work', 'Other'],
      selectedUser: {},
      organizationList: []
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var tmpEmail;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            //await this.getList()
            // console.log('page-user-acount-user', this.user)
            tmpEmail = _this.user.othEmail.length > 0 ? _this.user.othEmail : [{
              emailType: 'Work',
              value: ''
            }, {
              emailType: 'Work',
              value: ''
            }];
            _this.organizationList = _this.proOrganizationList || [];
            console.log('organizationList', _this.organizationList);
            console.log('proOrganizationList', _this.proOrganizationList);
            _this.selectedUser = {
              id: _this.user.id,
              uuid: _this.user.uuid,
              prefix: _this.user.prefix,
              givenName: _this.user.givenName,
              middleName: _this.user.middleName,
              familyName: _this.user.familyName,
              suffix: _this.user.suffix,
              genderCode: _this.user.genderCode,
              race: _this.user.race,
              nationality: _this.user.nationality,
              phone: _this.user.phone,
              mobile: _this.user.mobile,
              website: _this.user.website,
              birthday: _this.user.birthday,
              jobTitle: _this.user.jobTitle,
              department: _this.user.department,
              orgName: _this.user.orgName,
              yrInRole: _this.user.yrInRole,
              bio: _this.user.bio,
              othEmail: tmpEmail,
              organizationMembers: _this.user.organizationMembers.length > 0 ? [{
                organizationId: _this.user.organizationMembers[0].organization.id
              }] : [{
                organizationId: ''
              }]
            };
            _this.$store.dispatch('facets/getInitData', 'en').then(function () {
              _this.countryList = _this.$store.getters.countries;
              _this.genderList = _this.$store.getters.genders;
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    // getList() {
    //   const token = getCookie('ACCESS_TOKEN')
    //  return getAllOrganizations(token)
    //     .then(response => {
    //       this.organizationList = response.data.rows
    //     })
    //     .catch(error => {
    //       showDebugLog('getAllOrganizations-api-error', error)
    //       displayPopupMessage(error, 'error')
    //       // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
    //     })
    // },
    save: function save() {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var email = (0, _cookie.getCookie)('EMAIL');
      if (this.selectedUser.givenName === "") {
        var msg = "Given name is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.selectedUser.familyName === "") {
        var _msg = "Surname is missing";
        (0, _log.displayPopupMessage)(_msg, "error");
        return;
      }
      // console.log('token', token)
      var userToSubmit = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.selectedUser), {}, {
        organizationMembers: this.selectedUser.organizationMembers[0].organizationId === '' ? [] : this.selectedUser.organizationMembers
      });
      (0, _user.updateUserProfile)(token, userToSubmit).then(function (response) {
        var data = response.data;
        // console.log('page-user-save', response)
        _this2.selectedUser.prefix = data.prefix;
        _this2.selectedUser.givenName = data.givenName;
        _this2.selectedUser.middleName = data.middleName;
        _this2.selectedUser.familyName = data.familyName;
        _this2.selectedUser.suffix = data.suffix;
        _this2.selectedUser.genderCode = data.genderCode;
        _this2.selectedUser.race = data.race;
        _this2.selectedUser.nationality = data.nationality;
        _this2.selectedUser.phone = data.phone;
        _this2.selectedUser.mobile = data.mobile;
        _this2.selectedUser.website = data.website;
        _this2.selectedUser.birthday = data.birthday;
        _this2.selectedUser.genderCode = data.genderCode;
        _this2.selectedUser.jobTitle = data.jobTitle;
        _this2.selectedUser.department = data.department;
        _this2.selectedUser.orgName = data.orgName;
        _this2.selectedUser.yrInRole = data.yrInRole;
        _this2.selectedUser.bio = data.bio;
        _this2.selectedUser.othEmail = data.othEmail;
        _this2.selectedUser.organizationMembers = data.organizationMembers.length > 0 ? [{
          organizationId: data.organizationMembers[0].organization.id
        }] : [{
          organizationId: ''
        }];
        (0, _log.displayPopupMessage)('User information has been updated successfully', 'success');
        (0, _ga.writeGaEvent)(_this2, 'User', 'Update User Profile', email, "User Profile: ".concat(data.uuid));
      }).catch(function (error) {
        (0, _log.showDebugLog)('Page-user-Save-Err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};